import React from 'react';
import { Reveal, Section } from '@/components/ui';
import { resumeContent } from '@/content/resume';

/**
 * Skills section for the résumé/portfolio product variant (§11). See
 * `src/pages/ResumeDemo.tsx`.
 */
const ResumeSkills: React.FC = () => {
    return (
        <Section id="resume-skills" className="resume-skills" title="Skills" contained>
            <div className="resume-skills-list">
                {resumeContent.skills.map((skill, index) => (
                    <Reveal as="div" className="resume-skill" key={skill.name} delay={index * 100}>
                        <div className="resume-skill-label">
                            <span>{skill.name}</span>
                            {typeof skill.level === 'number' && <span>{skill.level}%</span>}
                        </div>
                        {typeof skill.level === 'number' && (
                            <div className="resume-skill-bar">
                                <div
                                    className="resume-skill-bar-fill"
                                    style={{ width: `${skill.level}%` }}
                                />
                            </div>
                        )}
                    </Reveal>
                ))}
            </div>
        </Section>
    );
};

export default ResumeSkills;
